import { IconProps } from '../icon-props-interface';
import '../icons.scss';

export const IconPrevPage = ({ color = 'var(--color-primary-1)' }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.75 8.26961L0.785811 5L4.75 1.73039L4.75 8.26961Z" fill={color} stroke={color} />
        </svg>
    </div>
);

export default IconPrevPage;
